export const formatPercentage = value => formatNumber(value) + '%'

export const formatNumber = value => {
	const decimals = _.isInteger(value) ? 0 : 2
	return new Intl.NumberFormat('nl-NL', {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	}).format(value)
}
